// oxlint-disable require-returns
// oxlint-disable require-param
// oxlint-disable group-exports
import { getStorage, setStorage } from '@sjzy/utils'

/** 带子系统前缀local---获取 */
export function getSysStorage<T = any>(key: string): T | string | null {
  return getStorage(`CRM-${key}`)
}
/**
 * 带子系统前缀local---存储
 */
export function setSysStorage(key: string, value: any) {
  setStorage(`CRM-${key}`, value)
}
